import React from 'react';
import '../style/formGroupTextInput.css'
import '../style/formGroupTableRow.css'
import CustomSelect from "./General/customSelect";
import DeleteIcon from "./icons/deleteIcon";
import EditIcon from "./icons/editIcon";

const FormGroupTableRow = (props) => {
	return (
		<tr className="appFormRefSettings-tr">
			<td>
				<input
					value={props.data.name}
					className="formGroupTableRow-textInput-input col-sm-12"
					type="text"
					name="name"
					onChange={(evt) =>{
						props.updateMedicalExpertFees({key:props.index, name:evt.target.name, value:evt.target.value})
					}}
				/>
			</td>
			<td>
				<input
					value={props.data.natureOfExpert}
					className="formGroupTableRow-textInput-input col-sm-12"
					type="text"
					name="natureOfExpert"
					onChange={(evt) =>{
						props.updateMedicalExpertFees({key:props.index, name:evt.target.name, value:evt.target.value})
					}}
				/>
			</td>
			<td>
				<input
					value={props.data.whySpecificExpert}
					className="formGroupTableRow-textInput-input col-sm-12"
					type="text"
					name="whySpecificExpert"
					onChange={(evt) =>{
						props.updateMedicalExpertFees({key:props.index, name:evt.target.name, value:evt.target.value})
					}}
				/>
			</td>
			<td>
				<div className="col-sm-12 formGroupTableRowSelect-table">
					<CustomSelect
						name={'breachCausationCpId'}
						onChange={(evt) => props.updateMedicalExpertFees({key:props.index, name:evt.target.name, value:evt.target.value} )}
						value={props.data.breachCausationCpId}
						options={
							[
								{key: '', value: ''},
								...props.breachCausationCp.options.map(o => ({key: o.id, value: o.name}))

							]
						}
					/>
				</div>
			</td>
			<td>
				<input
					value={props.data.partialEstimatedCost}
					className="formGroupTableRow-textInput-input col-sm-12"
					type="number"
					step="0.0001"
					name="partialEstimatedCost"
					onChange={(evt) =>{
						props.updateMedicalExpertFees({key:props.index, name:evt.target.name, value:evt.target.value})
					}}
				/>
			</td>
			<td>
				<input
					value={props.data.attendanceEstimatedCost}
					className="formGroupTableRow-textInput-input col-sm-12"
					type="number"
					step="0.0001"
					name="attendanceEstimatedCost"
					onChange={(evt) =>{
						props.updateMedicalExpertFees({key:props.index, name:evt.target.name, value:evt.target.value})
					}}
				/>
				<div className="formGroupTableRow-actions-wrapper" style={{top: "20px"}}>
					{props.index !== 0 && (
						<DeleteIcon
							onClick={() => props.removeMedicalExpertFeesTableRow(props.index)}
						/>
					)}
				</div>
			</td>
		</tr>
	)
};

export default FormGroupTableRow;